import React from 'react';
import {Radio, Alert} from 'antd';

import {FormFieldInputWrapperClasses, FormFieldWrapperClasses} from '../';
import {trb} from '../../../Utilities';

export const RadioFormField = (props) => {
    const {
        title,
        titleWithoutTranslate,
        className,
        classNameField,
        classNameTitle,
        inline,
        disabled,
        options,
        optionsLabel,
        optionsValue,
        translate,
        notify,
        small,
        meta,
        classNameItem,
        styleTitle,
        autosize,
        buttons
    } = props;

    const checkOption = (value, input) => {
        if (!options) {
            return null;
        }

        const optionValue = options.find(e => e[optionsValue] === value);

        if (optionValue) {
            return value;
        } else {
            input.onChange(undefined);
        }
    },
    RadioItem = buttons ? Radio.Button : Radio;

    return <div className={`${disabled ? 'disabled ' : ''}${FormFieldWrapperClasses(className, inline, disabled, true, small)}`}>
        {title && <div className={classNameTitle ? 'form-field-title position-static radio-text-wrap' + classNameTitle : inline ? 'form-field-title position-static col-12 mb-3 radio-text-wrap' : 'form-field-title position-static col-12 mb-3 radio-text-wrap'} style={styleTitle}>{titleWithoutTranslate ? title : trb(title)}</div>}
        <div className={
            classNameField
                ? 'form-field-item ' + classNameField
                : FormFieldInputWrapperClasses(meta.error, meta.submitError, meta.touched, inline, className)}>
            <Radio.Group
                className="w-100 text-center"
                onChange={props.input.onChange}
                value={checkOption(props.input.value, props.input)}
                disabled={disabled}
                size="large"
                optionType={buttons ? "button" : null}
                buttonStyle={buttons ? "solid" : null}
            >
                {options && options.map((item, index) =>
                    <RadioItem
                        className={classNameItem}
                        style={autosize ? {width: 'fit-content', minWidth: `calc(80% / ${options.length})`} : {width: `calc(100% / ${options.length})`}}
                        key={index}
                        disabled={item.disabled}
                        value={item[optionsValue]}
                    >
                        {translate ? trb(translate + item[optionsLabel]) : item[optionsLabel]}
                    </RadioItem>
                )}
            </Radio.Group>
        </div>
        {meta.touched && (meta.error || meta.submitError)
            ? <div className={inline ? 'form-field-error col-12 col-md-3' : 'form-field-error col-12'}>{meta.touched && (meta.error || meta.submitError)}</div>
            : <>{notify && <div className={inline ? 'form-field-notify col-12 col-md-3' : 'form-field-notify col-12'}><Alert showIcon message={trb(notify)}/></div>}</>
        }
    </div>
};
